import { SemanticUI } from '@iterable/deprecated_react_components';
import { StyledSemanticDropdown, UnitDropdownContainer } from './UnitDropdown.styled';
import { StyledFormField } from './styles';
import * as u from './unitOptions';

// type Props = {
//   /** Content appended to the dropdown. */
//   appendContent: string,
//   /** Label appended to the dropdown. */
//   appendLabel: string,
//   /** Additional class name. */
//   className: string,
//   /** If the options should be plural form. */
//   isPlural: boolean,
//   /** The label of the dropdown. */
//   label: string,
//   /** Callback function when value of unit changes. */
//   onChange: ({}, { value: string }) => void,
//   /** Value of the unit dropdown. */
//   value: string,
// };

const UnitDropdown = ({
  appendContent,
  appendLabel = '',
  className,
  isPlural = true,
  label = 'Unit',
  onChange,
  value,
  ...otherProps
}) => {
  const singularOptions = [u.HOUR, u.DAY, u.WEEK, u.MONTH];
  const pluralOptions = [u.HOURS, u.DAYS, u.WEEKS, u.MONTHS];

  return (
    <StyledFormField className={className} labelText={label} {...otherProps}>
      <UnitDropdownContainer>
        <StyledSemanticDropdown
          data-has-label={!!appendContent || !!appendLabel}
          onChange={onChange}
          options={isPlural ? pluralOptions : singularOptions}
          selection
          value={value}
        />
        {appendLabel && <SemanticUI.Label data-test="append-label">{appendLabel}</SemanticUI.Label>}
        {appendContent}
      </UnitDropdownContainer>
    </StyledFormField>
  );
};

export default UnitDropdown;
